import * as React from 'react';
import { useAuth } from 'react-oidc-context';

declare const rootUrl: string;

export interface UnderApprovalProps {
    logoutRedirectUri: string;
}

export const UnderApproval = ({ logoutRedirectUri }: UnderApprovalProps) => {
    const { signoutRedirect } = useAuth();

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="wrapper wrapper-content">
                    <div className="errorscreen middle-box text-center animated fadeInDown">
                        <h1 className="logo-name">
                            <img src="/Content/Images/Misc/vitalograph-logo.png" alt="" />
                        </h1>
                        <h3 className="font-bold">Under Approval</h3>
                        <div className="error-desc">
                            Your access request is under approval
                        </div>
                        <a className="btn btn-primary btn-outline btn-block"
                            onClick={() => signoutRedirect({ post_logout_redirect_uri: `${rootUrl}${logoutRedirectUri}` })}
                            style={{ marginTop: 25 + 'px' }}
                        >
                            Sign out
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
